/** The agent's model: Settings › Your agent's model (GigSync's, ADR 0052; the phone's, ADR 0040), and the chat's offer. */
export const model = {
    "model.title": "Your agent's model",
    "model.check": "Check again",
    "model.checking": "Checking this device…",
    "model.none": "This device has no on-device model.",
    "model.ready": "ready",
    "model.not_ready": "not ready",
    "model.free_mb": "{mb} MB free",
    "model.auto": "Auto",
    "model.auto_about": "GigSync's own model, on GigSync's computer in India, reads what you write to understand you; it is not kept. When it can't be reached, this phone's model if it is ready; otherwise lite mode.",
    "model.device": "On-device",
    "model.device_about": "Always use this device's own model. Falls back to lite mode only if it cannot answer.",
    "model.lite": "Lite mode",
    "model.lite_about": "No model at all. Rules and templates do every job: agreeing, recording, getting paid.",
    "model.ollama": "Ollama (dev)",
    "model.ollama_about": "Development builds only: a model served by `ollama serve` on this computer.",
    "model.ollama_model": "Ollama model",
    "model.ollama_choose": "Choose a model Ollama has",
    "model.ollama_name": "Ollama model name",
    "model.ollama_off": "Ollama is not running: start `ollama serve`, or type a name",
    "model.ollama_looking": "Looking for Ollama…",
    "model.use": "Use this model",
    "model.now": "Now answering: {model}",
    "model.still_works": "Everything still works in lite mode; a model only helps with wording.",
    "model.lite_label": "Lite mode (no model)",
    "model.ollama_label": "Ollama: {name} (dev)",
    "model.not_ready_lite": "{device} · not ready, so lite mode",
    "model.on_device_label": "On-device: {engine}",
    "model.auto_label": "Auto · {model}",
    "model.server_label": "GigSync's model",
    "model.offer": "Help your agent understand you better: download about {mb} MB to this phone.",
    "model.offer_download": "Download",
    "model.offer_later": "Later",
    "model.mobile_data": "You are on mobile data: this uses about {mb} MB of it.",
    "model.wifi_best": "Best on Wi-Fi.",
    "model.private": "It runs on this phone only: what you type never leaves it.",
    "model.downloading": "Downloading the model to this phone: {percent}% ({done} of {mb} MB)",
    "model.paused": "The model download stopped part-way. It carries on from where it was.",
    "model.resume": "Resume download",
    "model.ready_line": "Your agent now runs on this phone, even offline",
    "model.state_ready": "Ready",
    "model.state_downloadable": "Not downloaded",
    "model.state_downloading": "Downloading {percent}%",
    "model.line": "{name} · about {mb} MB · {state}",
    "model.download": "Download (about {mb} MB)",
    "model.remove": "Remove from this phone",
    "model.why.no_webgpu": "This browser can't run a model on this phone (no WebGPU). Lite mode does every job.",
    "model.why.gpu_limits": "This phone's graphics chip is too small for the model. Lite mode does every job.",
    "model.why.low_memory": "This phone has too little memory for the model. Lite mode does every job.",
    "model.why.unknown_memory": "This browser doesn't say how much memory this phone has, so the model isn't offered. The understanding pack does the job instead.",
    "model.why.low_storage": "Not enough free storage for the model. Free some space, then tap Check again.",
    "model.why.browser": "This browser can't keep the model. Use an up-to-date Chrome or Safari.",
};
//# sourceMappingURL=model.js.map